var map = {
	"./Speech_bubbles_hero_1.webp": 20330,
	"./Speech_bubbles_hero_2.webp": 29675,
	"./Speech_bubbles_hero_3.webp": 89768,
	"./Speech_bubbles_hero_4.webp": 86753,
	"./Speech_bubbles_hero_5.webp": 71910,
	"./Speech_bubbles_hero_6.webp": 19815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53161;